<template>
    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
    >
    <v-container fluid class="d-flex flex-column align-center">
      <!-- Centered Logo -->
      <v-row justify="center" class="mb-5">
        <v-col cols="auto">
          <div id="br_logo">
            <img id="br_logo_img" width="68px" height="68px" src="/assets/bison_router_logo.svg" alt="Bison Router Logo">
          </div>
        </v-col>
      </v-row>

      <v-card width="400" class="mx-auto mt-5">
        <v-form @submit.prevent="login">
          <v-card-title>
            <h1 class="display-1">Login</h1>
          </v-card-title>
          <v-card-text>
            <validation-provider
              v-slot="{ errors }"
              name="username"
              rules="required"
            >        
              <v-text-field v-model="username" :error-messages="errors"
                label="Username" prepend-icon="mdi-account-circle" required />
            </validation-provider>
  
            <v-text-field v-model="password"
              :type="showPassword ? 'text' : 'password'"
              label="Password"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              required
            />
  
          </v-card-text>
          <v-divider></v-divider>
  
          <v-alert v-if="status === 401"
            border="top"
            color="red lighten-2"
            dark
          >
            Invalid username or password.
          </v-alert>
  
          <v-card-actions>
            <v-btn :disabled="invalid" color="info" type="submit">Login</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
    </validation-observer>
  </template>
  
  <script>
  import { required } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  
  setInteractionMode('eager')
  
  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })
  
  export default {
    components: {
      ValidationProvider,
      ValidationObserver,
    },
  
    name: "LoginUser",
    data() {
      return {
        showPassword: false,
        username: "",
        password: "",
        status: null
      };
    },
    methods: {
      submit () {
        this.$refs.observer.validate()
      },
  
      login() {
        this.$store
          .dispatch("login", {
            username: this.username,
            password: this.password
          })
          .then(() => {
            this.$router.push({ path: "/about" });
          })
          .catch(err => {
            this.status = err.response.status;
          });
      },  
    }
  };
  </script>
  